import * as jwt_decode from "jwt-decode";
import { BaseCalss } from '../classes/base-config.class';

// export function setCookie(name, value, days) {
//     return new Promise((resolve, reject) => {
//         let expires;
//         if (days) {
//             const date = new Date();
//             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//             expires = '; expires=' + date.toUTCString();
//         } else {
//             expires = '';
//         }
//         document.cookie = name + '=' + value + expires + '; path=/;SameSite=Lax';
//         resolve(true);
//     });
// }

export function setCookie(
  name: string,
  value: string,
  days?: number,
  domain?: string
): Promise<boolean> {
  return new Promise(resolve => {
    let expires: string;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    } else {
      expires = '';
    }
    if (domain) {
      document.cookie = `${name}=${value}${expires}; path=/;SameSite=Lax;domain=${domain}`;
    } else {
      document.cookie = `${name}=${value}${expires}; path=/;SameSite=Lax;`;
    }
    resolve(true);
  });
}

export function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

// export function deleteCookie(name: string, domain = ''): void {
//   const conf = new BaseCalss()  ;
//   if(conf.env === 'TEST' && name === 'token') {
//     document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=Lax;domain=esmartlotto.ie`;
//   }  else if(conf.env === 'PROD' && name === 'token') {
//     document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=Lax;domain=smartlotto.ie`;
//   } else {
//     document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
//   }
// }



export function deleteCookie(name: string, domain = ''): void {
  if (domain) {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=Lax;domain=${domain}`;
  } else {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
}

export function getDecodedAccessToken(): any {
    let token = getCookie('token');
    try {
        return jwt_decode(token);
    }
    catch (Error) {
        return null;
    }
}

export function getDecodedJWTToken(token): any {
    // let token = getCookie('token');
    try {
        return jwt_decode(token);
    }
    catch (Error) {
        return null;
    }
}

export function getDecodedRegistrationToken(token): any {
    try {
        return jwt_decode(token);
    }
    catch (Error) {
        return null;
    }
}


